import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

async function purgeOrchestration(instanceId: string): Promise<void> {
    await apiClient.delete(
        `/FunctionAppsStarter/PurgeOrchestration/${instanceId}`,
    );
}

export function usePurgeOrchestration() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: purgeOrchestration,
        onSuccess: (_data, instanceId) => {
            queryClient.invalidateQueries({
                queryKey: ["orchestration-detail", instanceId],
            });
            queryClient.invalidateQueries({
                queryKey: ["orchestration-instances"],
            });
        },
    });
}
